"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc998ContractsFormValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.erc998ContractsFormValidationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
});
//# sourceMappingURL=validation.js.map